import React, { memo } from 'react';

import SearchCountryFilter from '../../../../components/Filters/SearchCountryFilter/SearchCountryFilter';

function CountryFilterWrapper({
  setGraphFilterCountries,
  graphFilterCountries,
}) {
  return (
    <SearchCountryFilter
      styles={{ marginBottom: 20 }}
      setSearchCountries={setGraphFilterCountries}
      searchCountries={graphFilterCountries}
    />
  );
}

export default memo(CountryFilterWrapper);
